import React from 'react';
import { convertAmount, useTranslation } from '@pascal/pascal-core';

export function WinPopUp({ winningAmount, currencyCode }) {
  const t = useTranslation();
  return (
    <div className='tb-win-popup-wrapper'>
      <div className='tb-win-popup-inner'>
        <div className='tb-win-popup-inside'>
          <div className='tb-win-popup-holder'>
            <div className='tb-win-popup-title-wrp'>
              <div className='tb-win-popup-title-line left'> </div>
              <p className='tb-win-popup-title'>{t('YOU_WIN')}</p>
              <div className='tb-win-popup-title-line'> </div>
            </div>
            <p className='tb-win-popup-amount'>
              {convertAmount(winningAmount)} {currencyCode}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
